export const CHART_CONSTANTS = {
  KLINES_URL: 'https://api.binance.com/api/v3/klines',
  TICKER_PRICES_URL: 'https://api.binance.com/api/v3/ticker/price',
  COINGECKO_SEARCH_URL: 'https://api.coingecko.com/api/v3/search',
  COINGECKO_MARKETS_URL: 'https://api.coingecko.com/api/v3/coins/markets',
  LIQUIDATIONS_URL: 'https://fapi.binance.com/fapi/v1/liquidationOrders',
  PROXY_URL: 'http://localhost:8080/liquidations',
  WS_SPOT_BASE_URL: 'wss://stream.binance.com:9443/ws',
  WS_FUTURES_BASE_URL: 'wss://fstream.binance.com/ws',
  WS_BASE_URL: 'wss://stream.binance.com:9443/ws',
  WS_STREAM_BASE_URL: 'wss://stream.binance.com:9443/stream?streams=',
  REQUEST_HEADERS: { 'Content-Type': 'application/json' },
  DEFAULT_SYMBOL: 'BTCUSDT',
  DEFAULT_INTERVAL: '4h',
  DEFAULT_KLINES_LIMIT: 1500,
  DEFAULT_LIQUIDATIONS_LIMIT: 100,
  LIQUIDATIONS_DAYS: 7,
};

export const CHART_COLORS = {
  BACKGROUND: '#141823',
  UP: '#269ea6',
  DOWN: '#a8aec0',
  BORDER_UP: '#269ea6',
  BORDER_DOWN: '#a8aec0',
  TEXT: 'white',
  AXIS: 'rgba(255,255,255,0.15)',
  GRID: 'rgba(255, 255, 255, 0.1)',
  CROSSHAIR: 'rgba(255, 255, 255, 0.7)',
  CURRENT_PRICE_LINE: 'rgba(255, 255, 255, 0.5)',
  CURRENT_PRICE_BG: '#269ea6',
  TOOLTIP_BG: 'rgba(20, 24, 35, 1)',
  MA_50: '#ff9800',
  MA_100: '#9c27b0',
  MA_200: '#ffffff',
  HOVER_HIGHLIGHT: 'rgb(70, 68, 68)',
  LIQ_BUY: 'rgba(0, 191, 255, 0.8)',
  LIQ_SELL: 'rgba(255, 165, 0, 0.8)',
  SMI_UP: '#26a69a',
  SMI_UP_DIM: 'rgba(38, 166, 154, 0.55)',
  SMI_DOWN: '#8b8e9b',
  SMI_DOWN_DIM: 'rgba(139, 142, 155, 0.55)',
  SMI_ZERO: 'rgba(255, 255, 255, 0.25)',
  SMI_SQUEEZE_ON: '#269ea6',
  SMI_SQUEEZE_OFF: 'rgba(255, 255, 255, 0.18)',
  SMI_PANEL_BG: '#1a1d26',
  ADX: '#efece6',
  ADX_DIM: 'rgba(240, 165, 0, 0.5)',
  ADX_PLUS_DI: 'rgba(38, 166, 154, 0.8)',
  ADX_MINUS_DI: 'rgba(239, 83, 80, 0.8)',
  ADX_AXIS: 'rgba(255,255,255,0.15)',
  ADX_KEY_LEVEL: '#efece6',
  RSI: '#ebe6ef',
  RSI_LINE: 'rgba(175, 108, 217, 0.7)',
  RSI_CENTER_BAND: 'rgba(149, 117, 205, 0.18)',
  RSI_OVERBOUGHT: 'rgba(239, 83, 80, 0.8)',
  RSI_OVERSOLD: 'rgba(38, 166, 154, 0.8)',
  RSI_KEY_LEVEL: 'rgba(255, 255, 255, 0.25)',
  RSI_PANEL_BG: '#1a1d26',
  RSI_AXIS: 'rgba(255,255,255,0.15)',
  VP_HIST: 'rgba(38, 166, 154, 0.4)',
  VP_HIST_POC: 'rgba(38, 166, 154, 0.7)',
  VP_HIST_VA: 'rgba(38, 166, 154, 0.5)',
  VP_POC_LINE: 'rgba(255, 193, 7, 0.8)',
  VP_VAH_LINE: 'rgba(139, 142, 155, 0.6)',
  VP_VAL_LINE: 'rgba(139, 142, 155, 0.6)',
  VP_POC_LABEL: '#ffc107',
  VP_VA_LABEL: 'rgba(255, 255, 255, 0.6)',
  PRICE_UP: '#26a69a',
  PRICE_DOWN: '#ef5350',
};

export const CHART_DEFAULTS = {
  PRICE_AXIS_WIDTH: 60,
  TIME_AXIS_HEIGHT: 25,
  INDICATOR_AXIS_WIDTH: 50,
  ZOOM_MIN: 0.2,
  ZOOM_MAX: 80,
  INITIAL_PAN_OFFSET_X: -70,
  TARGET_CANDLE_WIDTH_PX: 10,
  CANDLE_BODY_RATIO: 0.65,
  STORAGE_KEY_PAN_X: 'open_charts_pan_x',
  STORAGE_KEY_ZOOM_X: 'open_charts_zoom_x',
  STORAGE_KEY_PAN_Y: 'open_charts_pan_y',
  STORAGE_KEY_ZOOM_Y: 'open_charts_zoom_y',
  STORAGE_KEY_ANCHOR_INDEX: 'open_charts_anchor_index',
  STORAGE_KEY_SYMBOL: 'open_charts_symbol',
  STORAGE_KEY_INTERVAL: 'open_charts_interval',
  STORAGE_KEY_SUB_PANEL_VH: 'open_charts_sub_panel_vh',
  STORAGE_KEY_RSI_PANEL_VH: 'open_charts_rsi_panel_vh',
  STORAGE_KEY_WATCHLIST: 'open_charts_watchlist',
  STORAGE_KEY_SIDEBAR_OPEN: 'open_charts_sidebar_open',
  TOOLTIP_FADE_DELAY: 1500,
  TOOLTIP_FADE_STEP: 0.1,
  TOOLTIP_FADE_INTERVAL: 30,
  TOOLTIP_BLUR_PX: 6,
  TOOLTIP_OFFSET_X: 4,
  TOOLTIP_OFFSET_Y: 54,
  TOOLTIP_OVERLAY_ALPHA: 0.55,
  RECONNECT_DELAY: 5000,
  PRICE_LABEL_PADDING: 6,
  PRICE_LABEL_AREA: 15,
  PRICE_TICK_TARGET_PX: 40,
  MIN_TIME_LABEL_GAP_PX: 70,
  FONT_FAMILY: 'Arial',
  FONT_SIZE_AXIS: 13,
  FONT_SIZE_TIME: 12,
  FONT_SIZE_CURRENT_PRICE: 12,
  FONT_SIZE_TOOLTIP: 13,
  FONT_SIZE_CROSSHAIR_PRICE: 13,
  FONT_SIZE_CROSSHAIR_TIME: 12,
  SMI_LENGTH: 20,
  SMI_BB_MULT: 2,
  SMI_KC_LENGTH: 20,
  SMI_KC_MULT: 1.5,
  SMI_PANEL_HEIGHT_PCT: 0.15,
  SMI_VALUE_RANGE_RATIO: 0.4,
  SMI_SQUEEZE_DOT_SIZE: 4,
  ADX_LENGTH: 14,
  ADX_VALUE_MAX: 100,
  RSI_LENGTH: 14,
  RSI_VALUE_MIN: 0,
  RSI_VALUE_MAX: 100,
  RSI_OVERBOUGHT_LEVEL: 70,
  RSI_OVERSOLD_LEVEL: 30,
  INDICATOR_USABLE_HEIGHT_RATIO: 0.9,
  VP_BIN_COUNT: 300,
  VP_VALUE_AREA_RATIO: 0.7,
  VP_CLOSE_WEIGHT: 0.5,
  VP_MAX_WIDTH_RATIO: 0.35,
  VP_MIN_BAR_WIDTH: 2,
  SUB_PANEL_DEFAULT_VH: 20,
  SUB_PANEL_MIN_VH: 5,
  SUB_PANEL_MAX_VH: 40,
  RSI_PANEL_DEFAULT_VH: 15,
  RSI_PANEL_MIN_VH: 5,
  RSI_PANEL_MAX_VH: 40,
  KEY_LEVEL_GRAB_PX: 8,
  INDICATOR_TICK_STEP: 25,
  INDICATOR_LABEL_MARGIN: 18,
  WHEEL_ZOOM_Y_SENSITIVITY: 0.0008,
  WHEEL_ZOOM_X_SENSITIVITY: 0.001,
  WHEEL_ZOOM_X_MODIFIER: 0.3,
  WHEEL_PAN_SENSITIVITY: 0.5,
  EPS: 0.0001,
  VP_THROTTLE_MS: 200,
};


export const CHART_SYMBOLS = [
  'BTCUSDT', 'BCHUSDT', 'ETHUSDT', 'BNBUSDT', 'SOLUSDT',
  'XRPUSDT', 'ADAUSDT', 'AVAXUSDT',  'DOGEUSDT', 'MATICUSDT', 'LINKUSDT',
];

export const CHART_INTERVALS = [
  '1m', '5m', '15m', '30m', '1h', '2h', '4h','1d','1w','1M',
];

export const TICK_OPTIONS = [
  0.0001, 0.0002, 0.0005, 0.001, 0.002, 0.005,
  0.01, 0.02, 0.05, 0.1, 0.2, 0.5,
  1, 2, 5, 10, 20, 50, 100, 200, 500,
];

export const TIME_UNITS_MS = [
  60_000, 5 * 60_000, 15 * 60_000, 30 * 60_000,
  3_600_000, 2 * 3_600_000, 4 * 3_600_000, 6 * 3_600_000, 12 * 3_600_000,
  86_400_000, 2 * 86_400_000, 3 * 86_400_000, 7 * 86_400_000,
];